import e, { Component as o } from "react";
import { BodyRow as t } from "./BodyRow.js";
import n from "../../../../node_modules/classnames/index.js";
import r from "../../../utils/DomHandler.js";
import l from "../../../utils/ObjectUtils.js";
import { RowTogglerButton as i } from "./RowTogglerButton.js";
import { DotLoader as a } from "../../loaders/DotLoader/DotLoader.js";
import s from "../InfiniteScroller/InfiniteScrollTracker.js";
function p(e, o) {
  (null == o || o > e.length) && (o = e.length);
  for (var t = 0, n = Array(o); t < o; t++) n[t] = e[t];
  return n;
}
function c(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function d(e, o) {
  for (var t = 0; t < o.length; t++) {
    var n = o[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function u(e, o, t) {
  return o in e ? Object.defineProperty(e, o, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = t, e;
}
function g(e) {
  return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function h(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = null != arguments[o] ? arguments[o] : {},
      n = Object.keys(t);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    }))), n.forEach(function (o) {
      u(e, o, t[o]);
    });
  }
  return e;
}
function w(e, o) {
  return o = null != o ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : function (e, o) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t.push.apply(t, n);
    }
    return t;
  }(Object(o)).forEach(function (t) {
    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
  }), e;
}
function f(e, o) {
  return (f = Object.setPrototypeOf || function (e, o) {
    return e.__proto__ = o, e;
  })(e, o);
}
function v(e) {
  return function (e) {
    if (Array.isArray(e)) return p(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, o) {
    if (e) {
      if ("string" == typeof e) return p(e, o);
      var t = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t) return Array.from(t);
      if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return p(e, o);
    }
  }(e) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var R = function (o) {
  !function (e, o) {
    if ("function" != typeof o && null !== o) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(o && o.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), o && f(e, o);
  }(b, o);
  var p,
    R,
    S,
    y = (p = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        o,
        t = g(b);
      if (p) {
        var n = g(this).constructor;
        o = Reflect.construct(t, arguments, n);
      } else o = t.apply(this, arguments);
      return (e = o) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : c(this);
    });
  function b() {
    var e;
    return !function (e, o) {
      if (!(e instanceof o)) throw TypeError("Cannot call a class as a function");
    }(this, b), e = y.apply(this, arguments), u(c(e), "compareSelectionBy", void 0), u(c(e), "el", void 0), u(c(e), "rowTouched", void 0), u(c(e), "anchorRowIndex", void 0), u(c(e), "rangeRowIndex", void 0), u(c(e), "anchorCellIndex", void 0), u(c(e), "anchorRowFirst", void 0), u(c(e), "dragSelectionHelper", void 0), u(c(e), "initialDragPosition", void 0), u(c(e), "rowDragging", void 0), u(c(e), "draggedRowIndex", void 0), u(c(e), "droppedRowIndex", void 0), u(c(e), "state", {
      rowGroupHeaderStyleObject: {}
    }), u(c(e), "isContextMenuSelected", function (o) {
      return !!o && !!e.props.contextMenuSelection && e.equals(o, e.props.contextMenuSelection);
    }), u(c(e), "allowRowDrag", function (o) {
      return !e.allowCellSelection() && e.allowDrag(o);
    }), u(c(e), "allowCellSelection", function () {
      return e.props.cellSelection && !e.isRadioSelectionModeInColumn() && !e.isCheckboxSelectionModeInColumn();
    }), u(c(e), "updateFrozenRowStickyPosition", function () {
      var o;
      e.el.style.top = r.getOuterHeight(null === (o = e.el) || void 0 === o ? void 0 : o.previousElementSibling) + "px";
    }), u(c(e), "updateFrozenRowGroupHeaderStickyPosition", function () {
      var o,
        t = r.getOuterHeight(null === (o = e.el) || void 0 === o ? void 0 : o.previousElementSibling) + "px";
      e.state.rowGroupHeaderStyleObject && e.state.rowGroupHeaderStyleObject.top !== t && e.setState({
        rowGroupHeaderStyleObject: {
          top: t
        }
      });
    }), u(c(e), "onSingleSelection", function (o) {
      var t = e.isSelected(o.data),
        n = e.props.selection;
      t ? o.toggleable && (n = null, e.onUnselect({
        originalEvent: o.originalEvent,
        data: o.data,
        type: o.type
      })) : (n = o.data, e.onSelect({
        originalEvent: o.originalEvent,
        data: o.data,
        type: o.type
      })), e.focusOnElement(o.originalEvent, !0), e.props.onSelectionChange && n !== e.props.selection && e.props.onSelectionChange({
        originalEvent: o.originalEvent,
        value: n
      });
    }), u(c(e), "onMultipleSelection", function (o) {
      var t = e.isSelected(o.data),
        n = e.props.selection || [];
      if (t) {
        if (o.toggleable) {
          var r = e.findIndex(n, o.data);
          n = e.props.selection.filter(function (e, o) {
            return o !== r;
          }), e.onUnselect({
            originalEvent: o.originalEvent,
            data: o.data,
            type: o.type
          });
        } else n.length && (e.props.selection.forEach(function (t) {
          return e.onUnselect({
            originalEvent: o.originalEvent,
            data: t,
            type: o.type
          });
        }), n = [o.data], e.onSelect({
          originalEvent: o.originalEvent,
          data: o.data,
          type: o.type
        }));
      } else n = o.toggleable && e.isMultipleSelection() ? v(n).concat([o.data]) : [o.data], e.onSelect({
        originalEvent: o.originalEvent,
        data: o.data,
        type: o.type
      });
      e.focusOnElement(o.originalEvent, !0), e.props.onSelectionChange && n !== e.props.selection && e.props.onSelectionChange({
        originalEvent: o.originalEvent,
        value: n
      });
    }), u(c(e), "onRangeSelection", function (o) {
      r.clearSelection(), e.rangeRowIndex = e.allowCellSelection() ? o.rowIndex : o.index;
      var t = e.selectRange(o),
        n = e.isMultipleSelection() ? Array.from(new Set(v(e.props.selection || []).concat(v(t)))) : t;
      e.props.onSelectionChange && n !== e.props.selection && e.props.onSelectionChange({
        originalEvent: o.originalEvent,
        value: n
      }), e.anchorRowIndex = e.rangeRowIndex, e.anchorCellIndex = o.cellIndex, e.focusOnElement(o.originalEvent, !1);
    }), u(c(e), "selectRange", function (o) {
      var t,
        n,
        r = e.props.lazy && e.props.paginator;
      return r && (e.anchorRowIndex += e.anchorRowFirst, e.rangeRowIndex += e.props.first), e.rangeRowIndex > e.anchorRowIndex ? (t = e.anchorRowIndex, n = e.rangeRowIndex) : e.rangeRowIndex < e.anchorRowIndex ? (t = e.rangeRowIndex, n = e.anchorRowIndex) : t = n = e.rangeRowIndex, r && (t = Math.max(t - e.props.first, 0), n -= e.props.first), e.allowCellSelection() ? e.selectRangeOnCell(o, t, n) : e.selectRangeOnRow(o, t, n);
    }), u(c(e), "selectRangeOnRow", function (o, t, n) {
      for (var r = e.props.value, l = [], i = t; i <= n; i++) {
        var a = r[i];
        l.push(a), e.onSelect({
          originalEvent: o.originalEvent,
          data: a,
          type: "row"
        });
      }
      return l;
    }), u(c(e), "selectRangeOnCell", function (o, t, n) {
      var r,
        i,
        a = o.cellIndex;
      a > e.anchorCellIndex ? (r = e.anchorCellIndex, i = a) : a < e.anchorCellIndex ? (r = a, i = e.anchorCellIndex) : r = i = a;
      for (var s = e.props.value, p = [], c = t; c <= n; c++) for (var d = s[c], u = e.props.columns, g = r; g <= i; g++) {
        var h = u[g].props.field,
          w = {
            value: l.resolveFieldData(d, h),
            field: h,
            rowData: d,
            rowIndex: c,
            cellIndex: g,
            selected: !0
          };
        p.push(w), e.onSelect({
          originalEvent: o.originalEvent,
          data: w,
          type: "cell"
        });
      }
      return p;
    }), u(c(e), "onSelect", function (o) {
      e.allowCellSelection() ? e.props.onCellSelect && e.props.onCellSelect(w(h({
        originalEvent: o.originalEvent
      }, o.data), {
        type: o.type
      })) : e.props.onRowSelect && e.props.onRowSelect(o);
    }), u(c(e), "onUnselect", function (o) {
      e.allowCellSelection() ? e.props.onCellUnselect && e.props.onCellUnselect(w(h({
        originalEvent: o.originalEvent
      }, o.data), {
        type: o.type
      })) : e.props.onRowUnselect && e.props.onRowUnselect(o);
    }), u(c(e), "enableDragSelection", function (o) {
      e.props.dragSelection && !e.dragSelectionHelper && (e.dragSelectionHelper = document.createElement("div"), r.addClass(e.dragSelectionHelper, "datatable__drag-selection-helper"), e.initialDragPosition = {
        x: o.clientX,
        y: o.clientY
      }, e.dragSelectionHelper.style.top = "".concat(o.pageY, "px"), e.dragSelectionHelper.style.left = "".concat(o.pageX, "px"), e.bindDragSelectionEvents());
    }), u(c(e), "focusOnElement", function (o, t) {
      var n = o.currentTarget;
      if (!e.allowCellSelection()) {
        if (e.isCheckboxSelectionModeInColumn()) {
          var l = r.findSingle(n, "td.datatable__column--selectable .p-checkbox-box");
          l && l.focus();
        } else if (e.isRadioSelectionModeInColumn()) {
          var i = r.findSingle(n, 'td.datatable__column--selectable input[type="radio"]');
          i && i.focus();
        }
      }
      !t && n && n.focus();
    }), u(c(e), "onRowClick", function (o) {
      var t, n;
      if (!(e.allowCellSelection() || !e.allowSelection(o) || "data" in o && (null === (t = (n = e.props).isRowDisabled) || void 0 === t ? void 0 : t.call(n, o.data)))) {
        if (e.props.onRowClick && e.props.onRowClick(o), e.allowRowSelection() && (!e.props.isRowSelectable || !("data" in o) || e.props.isRowSelectable(o.data))) {
          if (e.allowRangeSelection(o)) e.onRangeSelection(o);else {
            var r = e.isRadioSelectionModeInColumn() || e.isCheckboxSelectionModeInColumn() || e.allowMetaKeySelection(o);
            e.anchorRowIndex = o.index, e.rangeRowIndex = o.index, e.anchorRowFirst = e.props.first, e.isSingleSelection() ? e.onSingleSelection(w(h({}, o), {
              toggleable: r,
              type: "row"
            })) : e.onMultipleSelection(w(h({}, o), {
              toggleable: r,
              type: "row"
            }));
          }
        } else e.focusOnElement(o.originalEvent);
        e.rowTouched = !1;
      }
    }), u(c(e), "onRowDoubleClick", function (o) {
      var t = o.originalEvent;
      !r.isClickable(t.target) && e.props.onRowDoubleClick && e.props.onRowDoubleClick(o);
    }), u(c(e), "onRowRightClick", function (o) {
      (e.props.onContextMenu || e.props.onContextMenuSelectionChange) && (r.clearSelection(), e.props.onContextMenuSelectionChange && e.props.onContextMenuSelectionChange({
        originalEvent: o.originalEvent,
        value: o.data
      }), e.props.onContextMenu && e.props.onContextMenu({
        originalEvent: o.originalEvent,
        data: o.data
      }), o.originalEvent.preventDefault());
    }), u(c(e), "onRowMouseDown", function (o) {
      r.clearSelection();
      var t = o.originalEvent;
      r.hasClass(t.target, "datatable__row-reorder-handle") ? t.currentTarget.draggable = !0 : t.currentTarget.draggable = !1, e.allowRowDrag(o) && (e.enableDragSelection(t), e.anchorRowIndex = o.index, e.rangeRowIndex = o.index, e.anchorRowFirst = e.props.first);
    }), u(c(e), "onRowMouseUp", function (o) {
      var t = o.index === e.anchorRowIndex;
      e.allowRowDrag(o) && !t && e.onRangeSelection(o);
    }), u(c(e), "onRowToggle", function (o) {
      var t,
        n = e.props.dataKey;
      if (e.props.groupRowsBy ? n === e.props.groupRowsBy : n) {
        var r = String(l.resolveFieldData(o.data, n));
        null !== (t = e.props.expandedRows ? h({}, e.props.expandedRows) : {})[r] ? (delete t[r], e.props.onRowCollapse && e.props.onRowCollapse({
          originalEvent: o.originalEvent,
          data: o.data
        })) : (t[r] = !0, e.props.onRowExpand && e.props.onRowExpand({
          originalEvent: o.originalEvent,
          data: o.data
        }));
      } else {
        var i = e.findIndex(e.props.expandedRows, o.data);
        t = e.props.expandedRows ? h({}, e.props.expandedRows) : [], -1 !== i ? (t = t.filter(function (e, o) {
          return o !== i;
        }), e.props.onRowCollapse && e.props.onRowCollapse({
          originalEvent: o.originalEvent,
          data: o.data
        })) : (t.push(o.data), e.props.onRowExpand && e.props.onRowExpand({
          originalEvent: o.originalEvent,
          data: o.data
        }));
      }
      e.props.onRowToggle && e.props.onRowToggle({
        data: t
      });
    }), u(c(e), "onRowDragStart", function (o) {
      var t = o.originalEvent,
        n = o.index;
      e.rowDragging = !0, e.draggedRowIndex = n, t.dataTransfer.setData("text", "b");
    }), u(c(e), "onRowDragOver", function (o) {
      var t = o.originalEvent,
        n = o.index;
      if (e.rowDragging && e.draggedRowIndex !== n) {
        var l = t.currentTarget,
          i = Number(r.getOffset(l).top) + r.getWindowScrollTop(),
          a = t.pageY,
          s = i + r.getOuterHeight(l) / 2,
          p = l.previousElementSibling;
        a < s ? (r.removeClass(l, "datatable__row--has-bottom-dragpoint"), e.droppedRowIndex = n, p ? r.addClass(p, "datatable__row--has-bottom-dragpoint") : r.addClass(l, "datatable__row--has-top-dragpoint")) : (p ? r.removeClass(p, "datatable__row--has-bottom-dragpoint") : r.addClass(l, "datatable__row--has-top-dragpoint"), e.droppedRowIndex = n + 1, r.addClass(l, "datatable__row--has-bottom-dragpoint"));
      }
      t.preventDefault();
    }), u(c(e), "onRowDragLeave", function (e) {
      var o = e.originalEvent.currentTarget,
        t = o.previousElementSibling;
      t && r.removeClass(t, "datatable__row--has-bottom-dragpoint"), r.removeClass(o, "datatable__row--has-bottom-dragpoint"), r.removeClass(o, "datatable__row--has-top-dragpoint");
    }), u(c(e), "onRowDragEnd", function (o) {
      var t = o.originalEvent;
      e.rowDragging = !1, e.draggedRowIndex = null, e.droppedRowIndex = null, t.currentTarget.draggable = !1;
    }), u(c(e), "onRowDrop", function (o) {
      var t = o.originalEvent;
      if (null !== e.droppedRowIndex) {
        var n = e.draggedRowIndex > e.droppedRowIndex ? e.droppedRowIndex : 0 === e.droppedRowIndex ? 0 : e.droppedRowIndex - 1,
          r = v(e.props.value);
        l.reorderArray(r, e.draggedRowIndex, n), e.props.onRowReorder && e.props.onRowReorder({
          originalEvent: t,
          value: r,
          dragIndex: e.draggedRowIndex,
          dropIndex: e.droppedRowIndex
        });
      }
      e.onRowDragLeave(o), e.onRowDragEnd(o), t.preventDefault();
    }), u(c(e), "onRadioChange", function (o) {
      e.onSingleSelection(w(h({}, o), {
        toggleable: !0,
        type: "radio"
      }));
    }), u(c(e), "onCheckboxChange", function (o) {
      e.onMultipleSelection(w(h({}, o), {
        toggleable: !0,
        type: "checkbox"
      }));
    }), u(c(e), "onDragSelectionMouseMove", function (o) {
      var t = e.initialDragPosition,
        n = t.x,
        r = t.y,
        l = o.clientX - n,
        i = o.clientY - r;
      i < 0 && (e.dragSelectionHelper.style.top = "".concat(o.pageY + 5, "px")), l < 0 && (e.dragSelectionHelper.style.left = "".concat(o.pageX + 5, "px")), e.dragSelectionHelper.style.height = "".concat(Math.abs(i), "px"), e.dragSelectionHelper.style.width = "".concat(Math.abs(l), "px"), o.preventDefault();
    }), u(c(e), "onDragSelectionMouseUp", function () {
      e.dragSelectionHelper && (e.dragSelectionHelper.remove(), e.dragSelectionHelper = null), document.removeEventListener("mousemove", e.onDragSelectionMouseMove), document.removeEventListener("mouseup", e.onDragSelectionMouseUp);
    }), u(c(e), "onCellClick", function (o) {
      if (!(!e.allowSelection(o) || e.props.isRowDisabled && "rowData" in o && e.props.isRowDisabled(o.rowData))) {
        if (e.props.onCellClick && e.props.onCellClick(o), e.allowCellSelection() && (!e.props.isRowSelectable || !("rowData" in o) || e.props.isRowSelectable(o.rowData))) {
          if (e.allowRangeSelection(o)) e.onRangeSelection(o);else {
            var t = e.allowMetaKeySelection(o),
              n = o.originalEvent,
              r = function (e, o) {
                if (null == e) return {};
                var t,
                  n,
                  r = function (e, o) {
                    if (null == e) return {};
                    var t,
                      n,
                      r = {},
                      l = Object.keys(e);
                    for (n = 0; n < l.length; n++) t = l[n], o.indexOf(t) >= 0 || (r[t] = e[t]);
                    return r;
                  }(e, o);
                if (Object.getOwnPropertySymbols) {
                  var l = Object.getOwnPropertySymbols(e);
                  for (n = 0; n < l.length; n++) t = l[n], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (r[t] = e[t]);
                }
                return r;
              }(o, ["originalEvent"]);
            e.anchorRowIndex = o.rowIndex, e.rangeRowIndex = o.rowIndex, e.anchorRowFirst = e.props.first, e.anchorCellIndex = o.cellIndex, e.isSingleSelection() ? e.onSingleSelection({
              originalEvent: n,
              data: r,
              toggleable: t,
              type: "cell"
            }) : e.onMultipleSelection({
              originalEvent: n,
              data: r,
              toggleable: t,
              type: "cell"
            });
          }
        }
        e.rowTouched = !1;
      }
    }), u(c(e), "onCellMouseDown", function (o) {
      e.allowCellDrag(o) && (e.enableDragSelection(o.originalEvent), e.anchorRowIndex = o.rowIndex, e.rangeRowIndex = o.rowIndex, e.anchorRowFirst = e.props.first, e.anchorCellIndex = o.cellIndex);
    }), u(c(e), "onCellMouseUp", function (o) {
      var t = o.rowIndex === e.anchorRowIndex && o.cellIndex === e.anchorCellIndex;
      e.allowCellDrag(o) && !t && e.onRangeSelection(o);
    }), u(c(e), "ref", function (o) {
      e.el = o, e.props.virtualScrollerContentRef && e.props.virtualScrollerContentRef(o);
    }), e;
  }
  return R = [{
    key: "equals",
    value: function value(e, o) {
      return this.allowCellSelection() ? (e.rowIndex === o.rowIndex || e.rowData === o.rowData) && (e.field === o.field || e.cellIndex === o.cellIndex) : "equals" === this.compareSelectionBy ? e === o : l.equals(e, o, this.props.dataKey);
    }
  }, {
    key: "isSubheaderGrouping",
    value: function value() {
      return this.props.rowGroupMode && "subheader" === this.props.rowGroupMode;
    }
  }, {
    key: "isSelectionEnabled",
    value: function value() {
      return this.props.selectionMode || null !== this.props.selectionModeInColumn || this.props.columns && this.props.columns.some(function (e) {
        return e && !!e.props.selectionMode;
      });
    }
  }, {
    key: "isRadioSelectionMode",
    value: function value() {
      return "radiobutton" === this.props.selectionMode;
    }
  }, {
    key: "isCheckboxSelectionMode",
    value: function value() {
      return "checkbox" === this.props.selectionMode;
    }
  }, {
    key: "isRadioSelectionModeInColumn",
    value: function value() {
      return "single" === this.props.selectionModeInColumn;
    }
  }, {
    key: "isCheckboxSelectionModeInColumn",
    value: function value() {
      return "multiple" === this.props.selectionModeInColumn;
    }
  }, {
    key: "isSingleSelection",
    value: function value() {
      return "single" === this.props.selectionMode && !this.isCheckboxSelectionModeInColumn() || !this.isRadioSelectionMode() && this.isRadioSelectionModeInColumn();
    }
  }, {
    key: "isMultipleSelection",
    value: function value() {
      return "multiple" === this.props.selectionMode && !this.isRadioSelectionModeInColumn() || this.isCheckboxSelectionModeInColumn();
    }
  }, {
    key: "isRadioOnlySelection",
    value: function value() {
      return this.isRadioSelectionMode() && this.isRadioSelectionModeInColumn();
    }
  }, {
    key: "isCheckboxOnlySelection",
    value: function value() {
      return this.isCheckboxSelectionMode() && this.isCheckboxSelectionModeInColumn();
    }
  }, {
    key: "isSelected",
    value: function value(e) {
      return !!e && !!this.props.selection && (this.props.selection instanceof Array ? this.findIndex(this.props.selection, e) > -1 : this.equals(e, this.props.selection));
    }
  }, {
    key: "isRowExpanded",
    value: function value(e) {
      return !!e && !!this.props.expandedRows && (this.isSubheaderGrouping() && this.props.expandableRowGroups ? this.isRowGroupExpanded(e) : this.props.dataKey ? !!this.props.expandedRows && void 0 !== this.props.expandedRows[l.resolveFieldData(e, this.props.dataKey)] : -1 !== this.findIndex(this.props.expandedRows, e));
    }
  }, {
    key: "isRowGroupExpanded",
    value: function value(e) {
      var o = this;
      return this.props.dataKey === this.props.groupRowsBy ? Object.keys(this.props.expandedRows).some(function (t) {
        return t === l.resolveFieldData(e, o.props.dataKey);
      }) : this.props.expandedRows.some(function (t) {
        return l.equals(t, e, o.props.groupRowsBy);
      });
    }
  }, {
    key: "isRowEditing",
    value: function value(e) {
      return "row" === this.props.editMode && !!e && !!this.props.editingRows && (this.props.dataKey ? !!this.props.editingRows && void 0 !== this.props.editingRows[l.resolveFieldData(e, this.props.dataKey)] : -1 !== this.findIndex(this.props.editingRows, e));
    }
  }, {
    key: "allowDrag",
    value: function value(e) {
      return this.props.dragSelection && this.isMultipleSelection() && !e.originalEvent.shiftKey;
    }
  }, {
    key: "allowCellDrag",
    value: function value(e) {
      return this.allowCellSelection() && this.allowDrag(e);
    }
  }, {
    key: "allowSelection",
    value: function value(e) {
      return !r.isClickable(e.originalEvent.target);
    }
  }, {
    key: "allowMetaKeySelection",
    value: function value(e) {
      return !this.rowTouched && (!this.props.metaKeySelection || this.props.metaKeySelection && (e.originalEvent.metaKey || e.originalEvent.ctrlKey));
    }
  }, {
    key: "allowRangeSelection",
    value: function value(e) {
      return this.isMultipleSelection() && e.originalEvent.shiftKey && null !== this.anchorRowIndex;
    }
  }, {
    key: "allowRowSelection",
    value: function value() {
      return (this.props.selectionMode || this.props.selectionModeInColumn) && !this.isRadioOnlySelection() && !this.isCheckboxOnlySelection();
    }
  }, {
    key: "getColumnsLength",
    value: function value() {
      return this.props.columns ? this.props.columns.length : 0;
    }
  }, {
    key: "getVirtualScrollerOption",
    value: function value(e, o) {
      return (o = o || this.props.virtualScrollerOptions) ? o[e] : null;
    }
  }, {
    key: "findIndex",
    value: function value(e, o) {
      var t = this;
      return (e || []).findIndex(function (e) {
        return t.equals(o, e);
      });
    }
  }, {
    key: "rowGroupHeaderStyle",
    value: function value() {
      return this.props.scrollable ? {
        top: this.state.rowGroupHeaderStyleObject.top
      } : null;
    }
  }, {
    key: "getRowKey",
    value: function value(e, o) {
      return this.props.dataKey ? l.resolveFieldData(e, this.props.dataKey) + "_" + o : o;
    }
  }, {
    key: "shouldRenderRowGroupHeader",
    value: function value(e, o, t) {
      var n = l.resolveFieldData(o, this.props.groupRowsBy),
        r = e[t - 1];
      return !r || n !== l.resolveFieldData(r, this.props.groupRowsBy);
    }
  }, {
    key: "shouldRenderRowGroupFooter",
    value: function value(e, o, t, n) {
      if (this.props.expandableRowGroups && !n) return !1;
      var r = l.resolveFieldData(o, this.props.groupRowsBy),
        i = e[t + 1];
      return !i || r !== l.resolveFieldData(i, this.props.groupRowsBy);
    }
  }, {
    key: "updateVirtualScrollerPosition",
    value: function value() {
      var e,
        o = r.getOuterHeight(null === (e = this.el) || void 0 === e ? void 0 : e.previousElementSibling);
      this.el.style.top = (this.el.style.top || 0) + o + "px";
    }
  }, {
    key: "onRowTouchEnd",
    value: function value() {
      this.rowTouched = !0;
    }
  }, {
    key: "bindDragSelectionEvents",
    value: function value() {
      document.addEventListener("mousemove", this.onDragSelectionMouseMove), document.addEventListener("mouseup", this.onDragSelectionMouseUp), document.body.appendChild(this.dragSelectionHelper);
    }
  }, {
    key: "unbindDragSelectionEvents",
    value: function value() {
      this.onDragSelectionMouseUp();
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.props.frozenRow && this.updateFrozenRowStickyPosition(), this.props.scrollable && "subheader" === this.props.rowGroupMode && this.updateFrozenRowGroupHeaderStickyPosition(), !this.props.isVirtualScrollerDisabled && this.getVirtualScrollerOption("vertical") && this.updateVirtualScrollerPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this.props.frozenRow && this.updateFrozenRowStickyPosition(), this.props.scrollable && "subheader" === this.props.rowGroupMode && this.updateFrozenRowGroupHeaderStickyPosition(), !this.props.isVirtualScrollerDisabled && this.getVirtualScrollerOption("vertical") && this.getVirtualScrollerOption("itemSize", e.virtualScrollerOptions) !== this.getVirtualScrollerOption("itemSize") && this.updateVirtualScrollerPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.props.dragSelection && this.unbindDragSelectionEvents();
    }
  }, {
    key: "renderEmptyContent",
    value: function value() {
      if (!this.props.loading) {
        var o = this.getColumnsLength(),
          t = l.getJSXElement(this.props.emptyMessage, {
            props: this.props,
            frozen: this.props.frozenRow
          });
        return e.createElement("tr", {
          className: "datatable__row datatable__row--body datatable__row--empty-message",
          role: "row"
        }, e.createElement("td", {
          className: "datatable__cell datatable__cell--body",
          colSpan: o,
          role: "cell"
        }, t));
      }
      return null;
    }
  }, {
    key: "renderLoader",
    value: function value() {
      if (this.props.loading) {
        var o, t;
        return e.createElement(a, {
          size: null !== (t = null === (o = this.props.infiniteScrollOptions) || void 0 === o ? void 0 : o.infiniteScrollLoaderSize) && void 0 !== t ? t : 12
        });
      }
      return null;
    }
  }, {
    key: "renderGroupHeader",
    value: function value(o, t, n, r, a) {
      if (r && this.shouldRenderRowGroupHeader(this.props.value, o, t)) {
        var s = this.rowGroupHeaderStyle(),
          p = this.props.expandableRowGroups && e.createElement(i, {
            onClick: this.onRowToggle,
            rowData: o,
            expanded: n,
            expandedRowIcon: this.props.expandedRowIcon,
            collapsedRowIcon: this.props.collapsedRowIcon
          }),
          c = l.getJSXElement(this.props.rowGroupHeaderTemplate, o, {
            index: t,
            props: this.props.tableProps
          });
        return e.createElement("tr", {
          className: "datatable__row datatable__row--body datatable__row--group-header",
          style: s,
          role: "row"
        }, e.createElement("td", {
          className: "datatable__cell datatable__cell--body",
          colSpan: a
        }, p, e.createElement("span", {
          className: "datatable__row-group-header-name"
        }, c)));
      }
      return null;
    }
  }, {
    key: "renderRow",
    value: function value(o, n, r, l, i) {
      if (!this.props.expandableRowGroups || r) {
        var a = !!this.isSelectionEnabled() && this.isSelected(o),
          s = this.isContextMenuSelected(o),
          p = this.allowRowSelection(),
          c = this.allowCellSelection(),
          d = this.isRowEditing(o);
        return e.createElement(t, {
          tableProps: this.props.tableProps,
          tableSelector: this.props.tableSelector,
          value: this.props.value,
          columns: this.props.columns,
          rowData: o,
          index: n,
          selected: a,
          contextMenuSelected: s,
          onRowClick: this.onRowClick,
          onRowDoubleClick: this.onRowDoubleClick,
          onRowRightClick: this.onRowRightClick,
          tabIndex: this.props.tabIndex,
          onRowTouchEnd: this.onRowTouchEnd,
          onRowMouseDown: this.onRowMouseDown,
          onRowMouseUp: this.onRowMouseUp,
          onRowToggle: this.onRowToggle,
          onRowDragStart: this.onRowDragStart,
          onRowDragOver: this.onRowDragOver,
          onRowDragLeave: this.onRowDragLeave,
          onRowDragEnd: this.onRowDragEnd,
          onRowDrop: this.onRowDrop,
          onRadioChange: this.onRadioChange,
          onCheckboxChange: this.onCheckboxChange,
          onCellClick: this.onCellClick,
          onCellMouseDown: this.onCellMouseDown,
          onCellMouseUp: this.onCellMouseUp,
          editing: d,
          editingRows: this.props.editingRows,
          editingMeta: this.props.editingMeta,
          editMode: this.props.editMode,
          onRowEditChange: this.props.onRowEditChange,
          onEditingMetaChange: this.props.onEditingMetaChange,
          groupRowsBy: this.props.groupRowsBy,
          compareSelectionBy: this.props.compareSelectionBy,
          dataKey: this.props.dataKey,
          rowGroupMode: this.props.rowGroupMode,
          onRowEditInit: this.props.onRowEditInit,
          rowEditValidator: this.props.rowEditValidator,
          onRowEditSave: this.props.onRowEditSave,
          onRowEditComplete: this.props.onRowEditComplete,
          onRowEditCancel: this.props.onRowEditCancel,
          selection: this.props.selection,
          allowRowSelection: p,
          allowCellSelection: c,
          selectOnEdit: this.props.selectOnEdit,
          selectionMode: this.props.selectionMode,
          selectionModeInColumn: this.props.selectionModeInColumn,
          cellClassName: this.props.cellClassName,
          responsiveLayout: this.props.responsiveLayout,
          frozenRow: this.props.frozenRow,
          showRowReorderElement: this.props.showRowReorderElement,
          expanded: r,
          disabled: l,
          selectable: i,
          expandedRowIcon: this.props.expandedRowIcon,
          collapsedRowIcon: this.props.collapsedRowIcon,
          rowClassName: this.props.rowClassName,
          virtualScrollerOptions: this.props.virtualScrollerOptions
        });
      }
    }
  }, {
    key: "renderExpansion",
    value: function value(o, t, n, r, i) {
      if (n && !(r && this.props.expandableRowGroups)) {
        var a = l.getJSXElement(this.props.rowExpansionTemplate, o, {
            index: t
          }),
          s = "".concat(this.props.tableSelector, "_content_").concat(t, "_expanded");
        return e.createElement("tr", {
          id: s,
          className: "datatable__row datatable__row--body datatable__row--expansion",
          role: "row"
        }, e.createElement("td", {
          className: "datatable__cell datatable__cell--body",
          role: "cell",
          colSpan: i
        }, a));
      }
      return null;
    }
  }, {
    key: "renderGroupFooter",
    value: function value(o, t, n, r, i) {
      if (r && this.shouldRenderRowGroupFooter(this.props.value, o, t, n)) {
        var a = l.getJSXElement(this.props.rowGroupFooterTemplate, o, {
          index: t,
          colSpan: i,
          props: this.props.tableProps
        });
        return e.createElement("tr", {
          className: "datatable__row datatable__row--body datatable__row--group-footer",
          role: "row"
        }, a);
      }
      return null;
    }
  }, {
    key: "renderContent",
    value: function value() {
      var o = this;
      return this.props.value.map(function (t, n) {
        var r = o.getVirtualScrollerOption("getItemOptions") ? o.getVirtualScrollerOption("getItemOptions")(n).index : o.props.first + n,
          l = o.getRowKey(t, r),
          i = o.isRowExpanded(t),
          a = !!o.props.isRowDisabled && o.props.isRowDisabled(t),
          s = !o.props.isRowSelectable || o.props.isRowSelectable(t),
          p = o.isSubheaderGrouping(),
          c = o.getColumnsLength(),
          d = o.renderGroupHeader(t, r, i, p, c),
          u = o.renderRow(t, r, i, a, s),
          g = o.renderExpansion(t, r, i, p, c),
          h = o.renderGroupFooter(t, r, i, p, c);
        return e.createElement(e.Fragment, {
          key: l
        }, d, u, g, h);
      });
    }
  }, {
    key: "render",
    value: function value() {
      var o,
        t = n("datatable__body", this.props.className),
        r = this.props.empty ? this.renderEmptyContent() : this.renderContent(),
        l = this.renderLoader();
      return e.createElement("tbody", {
        ref: this.ref,
        className: t
      }, r, this.props.infiniteScrollOptions && this.props.infiniteScrollOptions.canInfiniteScrollLoadMore && e.createElement("tr", {
        className: "datatable__row datatable__row--body datatable__row--loader",
        role: "row"
      }, e.createElement("td", {
        className: "datatable__cell datatable__cell--body datatable__cell--loader"
      }, this.props.loading ? l : (null === (o = this.props.value) || void 0 === o ? void 0 : o.length) > 0 && e.createElement(s, {
        loading: this.props.loading,
        canLoadMore: this.props.infiniteScrollOptions.canInfiniteScrollLoadMore,
        onNextPage: this.props.infiniteScrollOptions.onInfiniteScrollNextPage,
        height: this.props.infiniteScrollOptions.infiniteScrollLoaderSize
      }))));
    }
  }], d(b.prototype, R), S && d(b, S), b;
}(o);
export { R as TableBody };